
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12220',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12220",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.466",
  "data-fetching-client": "static-1.9664",
  "foundations-components": "static-1.7923",
  "foundations-components-legacy": "static-1.948",
  "foundations-theming": "static-1.4411",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.81",
  "head-dlb": "static-1.4994",
  "hs-test-utils": "static-1.8008",
  "hub-http-shared-msw-handlers": "static-1.9940",
  "hubspot-dlb": "static-2.1845",
  "hubspot-url-utils": "static-1.4115",
  "HubStyleTokens": "static-2.11463",
  "I18n": "static-7.1624",
  "jasmine-runner": "static-1.6461",
  "marketplace-storefront-base": "static-1.12281",
  "quartz": "static-1.7024",
  "react-dlb": "static-1.78",
  "react-rhumb": "static-1.16664",
  "reactive-variable-buffer-atom": "static-1.2853",
  "reporting-testing-lib": "static-1.9444",
  "settings-ui-lib": "static-1.12514",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7120",
  "ui-addon-i18n": "static-1.11145",
  "ui-addon-react-router-dom": "static-1.9538",
  "unified-auth": "static-1.482",
  "unified-auth-core-lib": "static-1.764",
  "usage-tracker": "static-1-cwunder-improve-network-queue-resilience.2",
  "usage-tracker-core": "static-1-cwunder-improve-network-queue-resilience.2",
  "customer-data-property-utils": "static-1.8083",
  "hub-http": "static-1.6217",
  "integrations-lib": "static-1.16094",
  "marketplace-ui-common": "static-1.19688",
  "property-management-iframe": "static-1.13108",
  "quartz-config": "static-1.802",
  "quartz-core": "static-1.6243",
  "quartz-routing": "static-1.454",
  "quick-fetch": "static-1.3912",
  "react": "static-7.185",
  "rpc-client-utils": "static-1.4645",
  "ts-schema": "static-1.4075",
  "ui-universal-auth": "static-1.8968",
  "UIComponents": "static-3.8409",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.446",
  "hs-promise-rejection-tracking": "static-1.5566",
  "PortalIdParser": "static-2.397",
  "raven": "static-3.5907",
  "raven-hubspot": "static-1.6214",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9619",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3395",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3301",
  "quartz-webpack": "static-1.3248",
  "bend-plugin-quartz-routing": "static-1.102",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4192",
  "floating-ui": "static-1.55",
  "foundations-assets": "static-1.4859",
  "foundations-theming-specialty": "static-1.2127",
  "framer-motion": "static-1.71",
  "hs-story-utils": "static-1.9421",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.22",
  "react-select-plus": "static-1.104",
  "react-utils": "static-2.5339",
  "react-virtualized": "static-2.98",
  "StyleGuideUI": "static-3.487",
  "tanstack-table": "static-1.54",
  "trellis-assets": "static-1.1909",
  "ui-fonts": "static-1.725",
  "ui-images": "static-2.1153",
  "bend-plugin-foundations-theming": "static-1.2894",
  "foundations-theming-base": "static-1.3396",
  "stylex": "static-1.32",
  "HeadJS": "static-2.760",
  "hs-test-utils-bend-plugin": "static-1.3119",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4322",
  "ai-components-ui-library": "static-1.8948",
  "ai-rendering-library": "static-1.10141",
  "chirp-fetch": "static-1.1881",
  "connections-embed-lib": "static-1.981",
  "copilot-toolkit": "static-1.11116",
  "feedback-loader": "static-1.29285",
  "laboratory-lib": "static-3.7152",
  "marketplace-embed": "static-1.22062",
  "marketplace-ui-details": "static-1.9584",
  "marketplace-ui-reviews": "static-1.19644",
  "marketplace-ui-tracking": "static-1.13859",
  "sanitize-text": "static-1.8136",
  "ui-addon-video-player": "static-1.8697",
  "usage-tracker-multi": "static-1-cwunder-improve-network-queue-resilience.2",
  "usage-tracker-session-replay": "static-1-cwunder-improve-network-queue-resilience.2",
  "wootric-nps": "static-1.6971",
  "quartz-head": "static-1.689",
  "web-vitals": "static-1.4",
  "apollo-link-hub-http": "static-2.4643",
  "immer": "static-1.33",
  "immerable": "static-1.4149",
  "highcharts": "static-8.103",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2499",
  "reporting-data": "static-1.67511",
  "cssUtils": "static-1.790",
  "flux-actions": "static-1.337",
  "HubStyle": "static-2.11770",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10203",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10362",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1-cwunder-improve-network-queue-resilience.2",
  "icons": "static-2.646",
  "marketplace-ui-apps-core": "static-1.18221",
  "storybook-react": "static-1.32",
  "trellis-story-utils": "static-1.4511",
  "foundations-components-test-utils": "static-1.5406",
  "quartz-i18n": "static-1.699",
  "react-input-autosize": "static-2.17",
  "google-sheets-integration-lib": "static-1.213",
  "microsoft-drive-integration-lib": "static-1.332",
  "fsm": "static-1.3726",
  "customer-data-objects": "static-1.7661",
  "property-translator": "static-1.5394",
  "hs-locale-management": "static-1.76",
  "frontend-preferences-client": "static-1.7924",
  "hs-promise-utils": "static-1.5588",
  "hubspot-apollo-client": "static-1.4873",
  "integrations-error-boundary-lib": "static-1.13509",
  "integrations-tracking-lib": "static-1.5594",
  "native-integrations-shared-strings": "static-1.7777",
  "reselect": "static-2.16",
  "sanitize": "static-1.4471",
  "superstore": "static-1.4757",
  "ui-shepherd-react": "static-3.10156",
  "ai-settings-ui-library": "static-1.7874",
  "hub-http-janus": "static-1.833",
  "hubspotter-http": "static-1.4647",
  "immutable-less": "static-1.4648",
  "marketplace-ui-client-types": "static-1.17095",
  "nav-meta": "static-1.29647",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10242",
  "ui-addon-upgrades": "static-9.17976",
  "inbound-db-properties-service-client": "static-1.3841",
  "property-management-common": "static-1.5396",
  "ui-addon-iframeable": "static-1.9051",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.534",
  "module-federation": "static-1.22",
  "quartz-auth": "static-1.699",
  "quartz-test": "static-1.699",
  "quartz-tracking": "static-1.403",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.55",
  "bender-build-tools": "static-1.3199",
  "usage-tracker-anonymous": "static-1-cwunder-improve-network-queue-resilience.2",
  "usage-tracker-public": "static-1-cwunder-improve-network-queue-resilience.2",
  "amplitude-session-replay-browser": "static-1.59",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21256",
  "ContentUtils": "static-1.68338",
  "customer-data-objects-ui-components": "static-1.13019",
  "sassPrefix": "static-1.155",
  "avatar-components": "static-1.2493",
  "customer-data-filters-ui": "static-1.39731",
  "customer-data-reference-ui-components": "static-1.13156",
  "embedded-academy-lib": "static-1.14297",
  "ExportDialog": "static-6.10385",
  "highlight.js": "static-1.78",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.41283",
  "reporting-snowflake": "static-1.56129",
  "reporting-ui-components": "static-2.64782",
  "reporting-visualizations": "static-1.59587",
  "ui-addon-teams": "static-1.21536",
  "magpie-lib": "static-1.5548",
  "navigation-components": "static-1.18010",
  "magpie-types": "static-1.5008",
  "simple-logging-lib": "static-1.3043",
  "ai-studio-lib": "static-1.11585",
  "app-governance-lib": "static-1.1514",
  "developer-experience-shared-components": "static-1.10503",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7992",
  "ui-product-approvals": "static-1.28120",
  "ui-tool-access": "static-1.10143",
  "usage-based-billing-components-lib": "static-1.8841",
  "inbound-db-meta-service-client": "static-1.3580",
  "persist-promise": "static-1.3692",
  "reference-resolvers": "static-1.8164",
  "ui-extensibility-client-types": "static-1.3922",
  "hubspot-apollo-cache": "static-1.332",
  "universal-page-editor-lib": "static-1.3008",
  "final-form": "static-1.69",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2753",
  "merchandise-lib": "static-1.263",
  "atom": "static-1.5066",
  "purchase-motions-components": "static-1.5876",
  "salesImages": "static-1.525",
  "batch-promise": "static-1.1535",
  "crm-component-utils": "static-1.39052",
  "crm-properties-common-lib": "static-1.5876",
  "customer-data-properties": "static-1.51516",
  "framework-data-schema-resolvers": "static-1.6878",
  "property-value-citations": "static-1.2130",
  "reference-resolvers-lite": "static-1.8088",
  "ui-business-units-lib": "static-1.9045",
  "navigation-messaging": "static-1.7337",
  "hubspotter-http-shared-msw-handlers": "static-1.9938",
  "cms-field-types": "static-1.4805",
  "content-icons-ui": "static-1.2225",
  "customer-data-ui-utilities": "static-1.9819",
  "events-data-lib": "static-1.212",
  "conversations-skeleton-state": "static-1.7241",
  "crm-message-bus": "static-1.42965",
  "customer-data-filters-ui-msw-helpers": "static-1.22166",
  "FormUrlGenerator": "static-2.4712",
  "framework-builder-read-service-client": "static-1.4000",
  "framework-data-schema-quick-fetch": "static-1.6783",
  "multi-account-reference-resolvers": "static-1.974",
  "onboarding-tours": "static-1.16582",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13657",
  "academy-common-lib": "static-1.13757",
  "content-assistance-lib": "static-1.7742",
  "dashboard-lib": "static-1.81505",
  "file-manager-components": "static-1.23602",
  "getting-started-shared-tasks": "static-1.18465",
  "hubspot-prosemirror": "static-1.18218",
  "hubspot-prosemirror-plugins": "static-1.18210",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19822",
  "share-with-third-party-component-lib": "static-1.8698",
  "ui-addon-draggable": "static-3.4759",
  "ui-asset-management-lib": "static-1.11016",
  "user-context": "static-1.5098",
  "growth-payments-core": "static-1.25355",
  "reporting-plugins": "static-1.10312",
  "reporting-reports": "static-1.67189",
  "idb-keyval": "static-1.43",
  "reactive-lib": "static-1.718",
  "nest": "static-1.220",
  "codemirror": "static-5.94",
  "react-codemirror": "static-1.10621",
  "framework-listing-lib": "static-2.28678",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30694",
  "apps-service-types": "static-1.3873",
  "oauth-service-types": "static-1.4243",
  "onboarding-scopes": "static-1.6456",
  "onboarding-tours-client": "static-1.4796",
  "platform-infra-nav-components": "static-1.7664",
  "subscription-experience-data-types": "static-1.14924",
  "crm-record-cards-service-types": "static-1.3592",
  "location-customization-utils-lib": "static-1.9230",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.5879",
  "signup-constants": "static-1.18821",
  "signup-ui-url-generator": "static-2.8041",
  "trials-service-types": "static-1.3898",
  "card-properties-lib": "static-1.44158",
  "commerce-subscription-lib": "static-1.37089",
  "crm-actions": "static-1.6320",
  "crm-cards-sdk": "static-1.43561",
  "customer-data-properties-shared-msw-handlers": "static-1.9267",
  "customer-data-tracking": "static-1.6882",
  "hs-resources": "static-1.148",
  "pulse": "static-1.569",
  "calling-global-api": "static-1.64487",
  "calling-internal-common": "static-1.31296",
  "calling-lifecycle-internal": "static-1.65869",
  "calling-lifecycle-messages": "static-1.58163",
  "commerce-products-lib": "static-1.9520",
  "conditional-properties-service-client": "static-1.3792",
  "crm-links": "static-1.6284",
  "external-options-client-types": "static-1.4153",
  "google-libphonenumber": "static-1.37",
  "inbounddb-objects-service-types": "static-1.4218",
  "meetings-icalendar-utils-lib": "static-1.625",
  "multi-currency-client-types": "static-1.3686",
  "object-builder-ui-client": "static-1.48714",
  "pipeline-validation-client-types": "static-1.3960",
  "smart-property-lib": "static-1.6946",
  "tiered-pricing": "static-1.1199",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.10987",
  "crm-pipelines-api-client-types": "static-1.4133",
  "react-dnd-compat": "static-1.4611",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.871",
  "growth-data-modal": "static-1.5418",
  "growth-onboarding-confetti": "static-1.3061",
  "growth-onboarding-next-action-utils": "static-1.1893",
  "onboarding-tours-utils": "static-1.648",
  "ui-shepherd-tracker": "static-1.7537",
  "academy-service-client": "static-1.3675",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39101",
  "FileManagerLib": "static-1.39242",
  "video-embed": "static-1.35731",
  "ui-coaching-tips": "static-1.28531",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11239",
  "video-data-lib": "static-1.34897",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8483",
  "payment-link-components": "static-1.23509",
  "ui-addon-emoji-picker": "static-1.9883",
  "EmailSignatureEditor": "static-1.24351",
  "viral-links-lib": "static-1.7056",
  "data-token-picker": "static-1.16399",
  "react-flip-move": "static-1.69",
  "nested-table": "static-1.221",
  "timezone-utils": "static-2.5238",
  "getting-started-shared-tasks-store": "static-1.17583",
  "ui-addon-opt": "static-4.8363",
  "campaign-roi-lib": "static-1.9085",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7320",
  "customer-data-views-management": "static-1.25432",
  "framework-data-table": "static-2.11898",
  "marketing-platform-lib": "static-1.6848",
  "nudge-client-utils": "static-1.2556",
  "nudge-custom-ui-functions": "static-1.1017",
  "app-users-service-client": "static-1.5592",
  "app-users-service-types": "static-1.5000",
  "mini-checkout-client": "static-1.26789",
  "onboarding-utils": "static-1.5347",
  "permissions-shared-i18n-strings-fe": "static-1.2045",
  "ui-coaching-tips-shared-config": "static-1.28516",
  "edison-service-client-types": "static-1.382",
  "crm_data": "static-4.91942",
  "customer-data-sidebar": "static-2.45989",
  "enrichment-properties-lib": "static-1.16064",
  "commerce-billing-lib": "static-1.19041",
  "commerce-shared-components-lib": "static-1.18521",
  "commerce-tools-ui-lib": "static-1.10349",
  "crm-fe-perf": "static-1.22897",
  "bend-plugin-pulse": "static-1.73",
  "directed-graph": "static-1.929",
  "event-emitter": "static-1.942",
  "fast-json-patch": "static-1.62",
  "calling-error-reporting": "static-1.31303",
  "shared-worker-versioning": "static-1.11031",
  "calling-usage-tracker": "static-1.6535",
  "voice-sms-access-library": "static-1.951",
  "commerce-permissions": "static-1.763",
  "products-iframe-lib": "static-1.7908",
  "products-ui-components-shared-msw-handlers": "static-1.10322",
  "data-agent-kit": "static-1.184",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10023",
  "policy-lib": "static-1.6774",
  "react-tinymce": "static-1.55218",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10086",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54344",
  "tinymce-plugins": "static-1.57458",
  "tinymce-themes": "static-1.56314",
  "onboarding-data-sync-lib": "static-1.1947",
  "growth-onboarding-next-action-components": "static-1.1921",
  "user-context-client": "static-1.4606",
  "audio-components": "static-1.5906",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.36753",
  "urlinator": "static-1.4531",
  "video-components": "static-1.13242",
  "outpost": "static-1.4177",
  "growth-onboarding-feedback-components": "static-1.6575",
  "content-media-composition-data-lib": "static-1.12235",
  "content-media-compositions": "static-2.16242",
  "media-bridge-lib": "static-1.18916",
  "commerce-tours-lib": "static-1.6080",
  "growth-onboarding-reliability": "static-1.5075",
  "sales-checkout-service-client": "static-1.3635",
  "draft-convert": "static-2.72",
  "draft-extend": "static-3.74",
  "draft-js": "static-5.77",
  "draft-plugins": "static-2.21666",
  "sales-email-signature-service-client": "static-1.3837",
  "ts-utils-lib": "static-1.167",
  "breeze-engine-lib": "static-1.601",
  "crm-export-dialog": "static-1.6290",
  "crm-index-associations-lib": "static-1.6435",
  "crm-view-components": "static-1.214",
  "react-beautiful-dnd": "static-1.13",
  "tanstack-virtual": "static-1.29",
  "nudge-custom-function-registry": "static-1.2313",
  "nudge-renderer-utils": "static-1.2632",
  "whisper-core-api": "static-1.6596",
  "InboxConnectUtils": "static-4.14788",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5504",
  "settings-content-modals": "static-1.46055",
  "crm_universal": "static-1.21998",
  "customer-data-email": "static-1.18025",
  "card-payment-highlight-lib": "static-1.37154",
  "card-subscription-highlight-lib": "static-1.39512",
  "commerce-contract-lib": "static-1.12014",
  "invoices-highlight-card-lib": "static-1.54705",
  "orders-highlight-card-lib": "static-1.21446",
  "products-highlight-card-lib": "static-1.17803",
  "quotes-highlight-card-lib": "static-1.71989",
  "crm-source-interpretation-lib": "static-1.5337",
  "utility-belt": "static-1.2529",
  "payments-enrollment-embed-lib": "static-1.22788",
  "stripe-embedded-components": "static-1.7495",
  "customer-data-rte": "static-1.32971",
  "cv-backend-services": "static-1.1552",
  "growth-onboarding-empty-states": "static-1.5710",
  "payments-post-enroll-local-storage-lib": "static-1.5102",
  "qrcode-generator": "static-1.68",
  "quotes-client-types": "static-1.38079",
  "calling-orchestration-schema": "static-1.35728",
  "sales-views-client-types": "static-1.4253",
  "hub-http-contrib": "static-1.3036",
  "interframe": "static-3.4754",
  "tinymce-data": "static-1.40429",
  "ui-addon-sales-email": "static-1.5206",
  "layout-dnd-components": "static-1.12437",
  "layout-dnd-utils": "static-1.11412",
  "ui-brand-identity-lib": "static-1.15249",
  "NamespacedHubStyle": "static-2.9054",
  "social-insights-client-types": "static-1.22075",
  "js-cookie": "static-1.18",
  "ably": "static-2.2",
  "crm-index-visualization-core": "static-1.4123",
  "checkout-sdk": "static-3.23632",
  "checkout-service-types": "static-1.3815",
  "company-details-components": "static-1.6193",
  "payment-method-components": "static-1.6904",
  "pricing-pages-ui-components": "static-1.13943",
  "quote-checkout-service-types": "static-1.3468",
  "upgrade-catalog-service-types": "static-1.3514",
  "access-control-lib": "static-1.10430",
  "EmailComponents": "static-1.54715",
  "EmailData": "static-1.53392",
  "redux-less": "static-2.9476",
  "sequences-lib": "static-1.8032",
  "ui-gdpr-components": "static-1.10342",
  "products-ui-components": "static-1.40038",
  "accounting-integrations-ui-components": "static-1.7056",
  "invoices-ui-lib": "static-1.54721",
  "commerce-products-api": "static-1.2277",
  "invoices-iframe-lib": "static-1.56779",
  "quotes-modal-lib": "static-1.102667",
  "quotes-ui-lib": "static-1.80710",
  "stripe-connect-js": "static-1.68",
  "draft-content-plugins": "static-1.28241",
  "ContentData": "static-1.68413",
  "layout-data-lib": "static-1.9737",
  "hub-http-rxjs": "static-1.799",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3933",
  "billing-payments-client-types": "static-1.3984",
  "react-performance-metrics-lib": "static-1.551",
  "account-and-billing-fintech-outages": "static-3.18578",
  "pricing-pages-api": "static-1.13808",
  "ContentComponents": "static-2.71294",
  "marketing-contacts-lib": "static-1.10003",
  "marketing-email-service-types": "static-1.1915",
  "messaging-editing-lib": "static-1.46249",
  "messaging-usage-based-billing-components-lib": "static-1.1111",
  "automation-ui-source-apps": "static-1.18863",
  "automation-ui-types": "static-1.19781",
  "messaging-types-lib": "static-1.45986",
  "onboarding-settings-client": "static-1.4499",
  "sequences-client-types-lib": "static-1.7889",
  "commerce-tax-lib": "static-1.521",
  "price-books-api": "static-1.649",
  "price-books-components": "static-1.707",
  "property-description-translator": "static-1.3839",
  "ramp-editor": "static-1.133",
  "commerce-analytics-service-client": "static-1.3623",
  "totals-ui-components": "static-1.23572",
  "SalesContentIndexUI": "static-3.9232",
  "advanced-menus-core": "static-1.15117",
  "advanced-menus-lib": "static-1.12060",
  "ui-memberships-settings-lib": "static-1.34023",
  "segments-query-core": "static-1.1414",
  "demographics-service-types": "static-1.1647",
  "eligibility-engine-service-types": "static-1.3179",
  "automation-ui-ubb": "static-1.5697",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7335",
  "data-token-views": "static-1.16380",
  "forms-utils-lib": "static-1.12567",
  "payments-embed-points-lib": "static-1.13016",
  "simple-menus-core": "static-1.15116",
  "simple-menus-lib": "static-1.16633",
  "ui-addon-draggable-compat": "static-2.4250",
  "videoconference-integration-components": "static-1.6808",
  "marketing-contacts-client": "static-1.7512",
  "automation-applications-service-types": "static-1.3502",
  "automation-platform-service-types": "static-1.2590",
  "ContentEditorUI": "static-2.77092",
  "short-messages-app-service-client": "static-1.3965",
  "web-interactives-components": "static-1.13751",
  "web-interactives-data": "static-1.13752",
  "messaging-shared-utils-lib": "static-1.560",
  "messaging-user-info-utils-lib": "static-1.730",
  "email-portal-health-service-types": "static-1.971",
  "line-items-api": "static-1.679",
  "commerce-totals-service-types": "static-1.3813",
  "FireAlarmUi": "static-1.4508",
  "sales-templates-service-types-lib": "static-1.4165",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21717",
  "automation-ui-usage-tracking": "static-1.21180",
  "data-studio-ubb": "static-1.2701",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27006",
  "collaboration-sidebar": "static-1.57783",
  "content-management-data-lib": "static-1.5376",
  "copilot-plugins": "static-1.11089",
  "cta-picker": "static-1.36378",
  "customer-agent-discovery-components-lib": "static-1.3060",
  "editor-components": "static-1.13220",
  "editor-iframe-lib": "static-1.8392",
  "error-messaging-js": "static-1.5187",
  "FormsCommonComponents": "static-1.85822",
  "pictos": "static-7.184",
  "react-transition-group": "static-2.64",
  "redux-request-state": "static-1.10641",
  "SharedLegalStrings": "static-1.1743",
  "smart-content-core": "static-1.42416",
  "smart-content-lib": "static-1.43069",
  "social-composer-lib": "static-1.59070",
  "structured-content-lib": "static-1.25166",
  "theme-previewer-lib": "static-1.53230",
  "tinymce-copilot": "static-1.16412",
  "xray-recommendation-lib": "static-1.7890",
  "automation-ui-routing": "static-1.21138",
  "sql-reporting-client-types": "static-1.5634",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42178",
  "campaigns-utils-lib": "static-1.3174",
  "reporting-enablement": "static-1.22895",
  "chatspot-widget-iframe": "static-1.21247",
  "collaboration-sidebar-common": "static-1.2580",
  "forms-ai-lib": "static-1.4310",
  "codemirror-dlb": "static-1.58651",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6426",
  "report-customization-components": "static-1.13142",
  "data-quality-ui-library": "static-1.13013",
  "html-to-image": "static-1.53",
  "reporting-filters": "static-1.304",
  "reporting-insights-lib": "static-1.1724"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12220",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.466",
  "data-fetching-client": "/data-fetching-client/static-1.9664",
  "foundations-components": "/foundations-components/static-1.7923",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.948",
  "foundations-theming": "/foundations-theming/static-1.4411",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.81",
  "head-dlb": "/head-dlb/static-1.4994",
  "hs-test-utils": "/hs-test-utils/static-1.8008",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9940",
  "hubspot-dlb": "/hubspot-dlb/static-2.1845",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4115",
  "HubStyleTokens": "/HubStyleTokens/static-2.11463",
  "I18n": "/I18n/static-7.1624",
  "jasmine-runner": "/jasmine-runner/static-1.6461",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12281",
  "quartz": "/quartz/static-1.7024",
  "react-dlb": "/react-dlb/static-1.78",
  "react-rhumb": "/react-rhumb/static-1.16664",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2853",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9444",
  "settings-ui-lib": "/settings-ui-lib/static-1.12514",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7120",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11145",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9538",
  "unified-auth": "/unified-auth/static-1.482",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.764",
  "usage-tracker": "/usage-tracker/static-1-cwunder-improve-network-queue-resilience.2",
  "usage-tracker-core": "/usage-tracker-core/static-1-cwunder-improve-network-queue-resilience.2",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8083",
  "hub-http": "/hub-http/static-1.6217",
  "integrations-lib": "/integrations-lib/static-1.16094",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19688",
  "property-management-iframe": "/property-management-iframe/static-1.13108",
  "quartz-config": "/quartz-config/static-1.802",
  "quartz-core": "/quartz-core/static-1.6243",
  "quartz-routing": "/quartz-routing/static-1.454",
  "quick-fetch": "/quick-fetch/static-1.3912",
  "react": "/react/static-7.185",
  "rpc-client-utils": "/rpc-client-utils/static-1.4645",
  "ts-schema": "/ts-schema/static-1.4075",
  "ui-universal-auth": "/ui-universal-auth/static-1.8968",
  "UIComponents": "/UIComponents/static-3.8409",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.446",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5566",
  "PortalIdParser": "/PortalIdParser/static-2.397",
  "raven": "/raven/static-3.5907",
  "raven-hubspot": "/raven-hubspot/static-1.6214",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9619",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3395",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3301",
  "quartz-webpack": "/quartz-webpack/static-1.3248",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.102",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4192",
  "floating-ui": "/floating-ui/static-1.55",
  "foundations-assets": "/foundations-assets/static-1.4859",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2127",
  "framer-motion": "/framer-motion/static-1.71",
  "hs-story-utils": "/hs-story-utils/static-1.9421",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.22",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-utils": "/react-utils/static-2.5339",
  "react-virtualized": "/react-virtualized/static-2.98",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "tanstack-table": "/tanstack-table/static-1.54",
  "trellis-assets": "/trellis-assets/static-1.1909",
  "ui-fonts": "/ui-fonts/static-1.725",
  "ui-images": "/ui-images/static-2.1153",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2894",
  "foundations-theming-base": "/foundations-theming-base/static-1.3396",
  "stylex": "/stylex/static-1.32",
  "HeadJS": "/HeadJS/static-2.760",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3119",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4322",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8948",
  "ai-rendering-library": "/ai-rendering-library/static-1.10141",
  "chirp-fetch": "/chirp-fetch/static-1.1881",
  "connections-embed-lib": "/connections-embed-lib/static-1.981",
  "copilot-toolkit": "/copilot-toolkit/static-1.11116",
  "feedback-loader": "/feedback-loader/static-1.29285",
  "laboratory-lib": "/laboratory-lib/static-3.7152",
  "marketplace-embed": "/marketplace-embed/static-1.22062",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9584",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19644",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13859",
  "sanitize-text": "/sanitize-text/static-1.8136",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8697",
  "usage-tracker-multi": "/usage-tracker-multi/static-1-cwunder-improve-network-queue-resilience.2",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1-cwunder-improve-network-queue-resilience.2",
  "wootric-nps": "/wootric-nps/static-1.6971",
  "quartz-head": "/quartz-head/static-1.689",
  "web-vitals": "/web-vitals/static-1.4",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4643",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4149",
  "highcharts": "/highcharts/static-8.103",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2499",
  "reporting-data": "/reporting-data/static-1.67511",
  "cssUtils": "/cssUtils/static-1.790",
  "flux-actions": "/flux-actions/static-1.337",
  "HubStyle": "/HubStyle/static-2.11770",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10203",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10362",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1-cwunder-improve-network-queue-resilience.2",
  "icons": "/icons/static-2.646",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18221",
  "storybook-react": "/storybook-react/static-1.32",
  "trellis-story-utils": "/trellis-story-utils/static-1.4511",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5406",
  "quartz-i18n": "/quartz-i18n/static-1.699",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.213",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.332",
  "fsm": "/fsm/static-1.3726",
  "customer-data-objects": "/customer-data-objects/static-1.7661",
  "property-translator": "/property-translator/static-1.5394",
  "hs-locale-management": "/hs-locale-management/static-1.76",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7924",
  "hs-promise-utils": "/hs-promise-utils/static-1.5588",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4873",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13509",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5594",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7777",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4471",
  "superstore": "/superstore/static-1.4757",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10156",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7874",
  "hub-http-janus": "/hub-http-janus/static-1.833",
  "hubspotter-http": "/hubspotter-http/static-1.4647",
  "immutable-less": "/immutable-less/static-1.4648",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17095",
  "nav-meta": "/nav-meta/static-1.29647",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10242",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17976",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3841",
  "property-management-common": "/property-management-common/static-1.5396",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9051",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.534",
  "module-federation": "/module-federation/static-1.22",
  "quartz-auth": "/quartz-auth/static-1.699",
  "quartz-test": "/quartz-test/static-1.699",
  "quartz-tracking": "/quartz-tracking/static-1.403",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.55",
  "bender-build-tools": "/bender-build-tools/static-1.3199",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1-cwunder-improve-network-queue-resilience.2",
  "usage-tracker-public": "/usage-tracker-public/static-1-cwunder-improve-network-queue-resilience.2",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21256",
  "ContentUtils": "/ContentUtils/static-1.68338",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13019",
  "sassPrefix": "/sassPrefix/static-1.155",
  "avatar-components": "/avatar-components/static-1.2493",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39731",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13156",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14297",
  "ExportDialog": "/ExportDialog/static-6.10385",
  "highlight.js": "/highlight.js/static-1.78",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.41283",
  "reporting-snowflake": "/reporting-snowflake/static-1.56129",
  "reporting-ui-components": "/reporting-ui-components/static-2.64782",
  "reporting-visualizations": "/reporting-visualizations/static-1.59587",
  "ui-addon-teams": "/ui-addon-teams/static-1.21536",
  "magpie-lib": "/magpie-lib/static-1.5548",
  "navigation-components": "/navigation-components/static-1.18010",
  "magpie-types": "/magpie-types/static-1.5008",
  "simple-logging-lib": "/simple-logging-lib/static-1.3043",
  "ai-studio-lib": "/ai-studio-lib/static-1.11585",
  "app-governance-lib": "/app-governance-lib/static-1.1514",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10503",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7992",
  "ui-product-approvals": "/ui-product-approvals/static-1.28120",
  "ui-tool-access": "/ui-tool-access/static-1.10143",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8841",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3580",
  "persist-promise": "/persist-promise/static-1.3692",
  "reference-resolvers": "/reference-resolvers/static-1.8164",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3922",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.332",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3008",
  "final-form": "/final-form/static-1.69",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2753",
  "merchandise-lib": "/merchandise-lib/static-1.263",
  "atom": "/atom/static-1.5066",
  "purchase-motions-components": "/purchase-motions-components/static-1.5876",
  "salesImages": "/salesImages/static-1.525",
  "batch-promise": "/batch-promise/static-1.1535",
  "crm-component-utils": "/crm-component-utils/static-1.39052",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5876",
  "customer-data-properties": "/customer-data-properties/static-1.51516",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6878",
  "property-value-citations": "/property-value-citations/static-1.2130",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8088",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9045",
  "navigation-messaging": "/navigation-messaging/static-1.7337",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9938",
  "cms-field-types": "/cms-field-types/static-1.4805",
  "content-icons-ui": "/content-icons-ui/static-1.2225",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9819",
  "events-data-lib": "/events-data-lib/static-1.212",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7241",
  "crm-message-bus": "/crm-message-bus/static-1.42965",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22166",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4712",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4000",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6783",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.974",
  "onboarding-tours": "/onboarding-tours/static-1.16582",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13657",
  "academy-common-lib": "/academy-common-lib/static-1.13757",
  "content-assistance-lib": "/content-assistance-lib/static-1.7742",
  "dashboard-lib": "/dashboard-lib/static-1.81505",
  "file-manager-components": "/file-manager-components/static-1.23602",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18465",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18218",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18210",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19822",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8698",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4759",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11016",
  "user-context": "/user-context/static-1.5098",
  "growth-payments-core": "/growth-payments-core/static-1.25355",
  "reporting-plugins": "/reporting-plugins/static-1.10312",
  "reporting-reports": "/reporting-reports/static-1.67189",
  "idb-keyval": "/idb-keyval/static-1.43",
  "reactive-lib": "/reactive-lib/static-1.718",
  "nest": "/nest/static-1.220",
  "codemirror": "/codemirror/static-5.94",
  "react-codemirror": "/react-codemirror/static-1.10621",
  "framework-listing-lib": "/framework-listing-lib/static-2.28678",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30694",
  "apps-service-types": "/apps-service-types/static-1.3873",
  "oauth-service-types": "/oauth-service-types/static-1.4243",
  "onboarding-scopes": "/onboarding-scopes/static-1.6456",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4796",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7664",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14924",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3592",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9230",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.5879",
  "signup-constants": "/signup-constants/static-1.18821",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8041",
  "trials-service-types": "/trials-service-types/static-1.3898",
  "card-properties-lib": "/card-properties-lib/static-1.44158",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37089",
  "crm-actions": "/crm-actions/static-1.6320",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43561",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9267",
  "customer-data-tracking": "/customer-data-tracking/static-1.6882",
  "hs-resources": "/hs-resources/static-1.148",
  "pulse": "/pulse/static-1.569",
  "calling-global-api": "/calling-global-api/static-1.64487",
  "calling-internal-common": "/calling-internal-common/static-1.31296",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65869",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58163",
  "commerce-products-lib": "/commerce-products-lib/static-1.9520",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3792",
  "crm-links": "/crm-links/static-1.6284",
  "external-options-client-types": "/external-options-client-types/static-1.4153",
  "google-libphonenumber": "/google-libphonenumber/static-1.37",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4218",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.625",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3686",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48714",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3960",
  "smart-property-lib": "/smart-property-lib/static-1.6946",
  "tiered-pricing": "/tiered-pricing/static-1.1199",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10987",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4133",
  "react-dnd-compat": "/react-dnd-compat/static-1.4611",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.871",
  "growth-data-modal": "/growth-data-modal/static-1.5418",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3061",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1893",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.648",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7537",
  "academy-service-client": "/academy-service-client/static-1.3675",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39101",
  "FileManagerLib": "/FileManagerLib/static-1.39242",
  "video-embed": "/video-embed/static-1.35731",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28531",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11239",
  "video-data-lib": "/video-data-lib/static-1.34897",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8483",
  "payment-link-components": "/payment-link-components/static-1.23509",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9883",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24351",
  "viral-links-lib": "/viral-links-lib/static-1.7056",
  "data-token-picker": "/data-token-picker/static-1.16399",
  "react-flip-move": "/react-flip-move/static-1.69",
  "nested-table": "/nested-table/static-1.221",
  "timezone-utils": "/timezone-utils/static-2.5238",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17583",
  "ui-addon-opt": "/ui-addon-opt/static-4.8363",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9085",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7320",
  "customer-data-views-management": "/customer-data-views-management/static-1.25432",
  "framework-data-table": "/framework-data-table/static-2.11898",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6848",
  "nudge-client-utils": "/nudge-client-utils/static-1.2556",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1017",
  "app-users-service-client": "/app-users-service-client/static-1.5592",
  "app-users-service-types": "/app-users-service-types/static-1.5000",
  "mini-checkout-client": "/mini-checkout-client/static-1.26789",
  "onboarding-utils": "/onboarding-utils/static-1.5347",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2045",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28516",
  "edison-service-client-types": "/edison-service-client-types/static-1.382",
  "crm_data": "/crm_data/static-4.91942",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45989",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16064",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19041",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18521",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10349",
  "crm-fe-perf": "/crm-fe-perf/static-1.22897",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.73",
  "directed-graph": "/directed-graph/static-1.929",
  "event-emitter": "/event-emitter/static-1.942",
  "fast-json-patch": "/fast-json-patch/static-1.62",
  "calling-error-reporting": "/calling-error-reporting/static-1.31303",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11031",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6535",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.951",
  "commerce-permissions": "/commerce-permissions/static-1.763",
  "products-iframe-lib": "/products-iframe-lib/static-1.7908",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10322",
  "data-agent-kit": "/data-agent-kit/static-1.184",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10023",
  "policy-lib": "/policy-lib/static-1.6774",
  "react-tinymce": "/react-tinymce/static-1.55218",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10086",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54344",
  "tinymce-plugins": "/tinymce-plugins/static-1.57458",
  "tinymce-themes": "/tinymce-themes/static-1.56314",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1947",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1921",
  "user-context-client": "/user-context-client/static-1.4606",
  "audio-components": "/audio-components/static-1.5906",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.36753",
  "urlinator": "/urlinator/static-1.4531",
  "video-components": "/video-components/static-1.13242",
  "outpost": "/outpost/static-1.4177",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6575",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12235",
  "content-media-compositions": "/content-media-compositions/static-2.16242",
  "media-bridge-lib": "/media-bridge-lib/static-1.18916",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6080",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5075",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3635",
  "draft-convert": "/draft-convert/static-2.72",
  "draft-extend": "/draft-extend/static-3.74",
  "draft-js": "/draft-js/static-5.77",
  "draft-plugins": "/draft-plugins/static-2.21666",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3837",
  "ts-utils-lib": "/ts-utils-lib/static-1.167",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.601",
  "crm-export-dialog": "/crm-export-dialog/static-1.6290",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6435",
  "crm-view-components": "/crm-view-components/static-1.214",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "tanstack-virtual": "/tanstack-virtual/static-1.29",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2313",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2632",
  "whisper-core-api": "/whisper-core-api/static-1.6596",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14788",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5504",
  "settings-content-modals": "/settings-content-modals/static-1.46055",
  "crm_universal": "/crm_universal/static-1.21998",
  "customer-data-email": "/customer-data-email/static-1.18025",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37154",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39512",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12014",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54705",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21446",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17803",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71989",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5337",
  "utility-belt": "/utility-belt/static-1.2529",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22788",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7495",
  "customer-data-rte": "/customer-data-rte/static-1.32971",
  "cv-backend-services": "/cv-backend-services/static-1.1552",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5710",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5102",
  "qrcode-generator": "/qrcode-generator/static-1.68",
  "quotes-client-types": "/quotes-client-types/static-1.38079",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35728",
  "sales-views-client-types": "/sales-views-client-types/static-1.4253",
  "hub-http-contrib": "/hub-http-contrib/static-1.3036",
  "interframe": "/interframe/static-3.4754",
  "tinymce-data": "/tinymce-data/static-1.40429",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5206",
  "layout-dnd-components": "/layout-dnd-components/static-1.12437",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11412",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15249",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9054",
  "social-insights-client-types": "/social-insights-client-types/static-1.22075",
  "js-cookie": "/js-cookie/static-1.18",
  "ably": "/ably/static-2.2",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4123",
  "checkout-sdk": "/checkout-sdk/static-3.23632",
  "checkout-service-types": "/checkout-service-types/static-1.3815",
  "company-details-components": "/company-details-components/static-1.6193",
  "payment-method-components": "/payment-method-components/static-1.6904",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.13943",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3468",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3514",
  "access-control-lib": "/access-control-lib/static-1.10430",
  "EmailComponents": "/EmailComponents/static-1.54715",
  "EmailData": "/EmailData/static-1.53392",
  "redux-less": "/redux-less/static-2.9476",
  "sequences-lib": "/sequences-lib/static-1.8032",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10342",
  "products-ui-components": "/products-ui-components/static-1.40038",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7056",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54721",
  "commerce-products-api": "/commerce-products-api/static-1.2277",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56779",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102667",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80710",
  "stripe-connect-js": "/stripe-connect-js/static-1.68",
  "draft-content-plugins": "/draft-content-plugins/static-1.28241",
  "ContentData": "/ContentData/static-1.68413",
  "layout-data-lib": "/layout-data-lib/static-1.9737",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.799",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3933",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.3984",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.551",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18578",
  "pricing-pages-api": "/pricing-pages-api/static-1.13808",
  "ContentComponents": "/ContentComponents/static-2.71294",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10003",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1915",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46249",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1111",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18863",
  "automation-ui-types": "/automation-ui-types/static-1.19781",
  "messaging-types-lib": "/messaging-types-lib/static-1.45986",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4499",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7889",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.521",
  "price-books-api": "/price-books-api/static-1.649",
  "price-books-components": "/price-books-components/static-1.707",
  "property-description-translator": "/property-description-translator/static-1.3839",
  "ramp-editor": "/ramp-editor/static-1.133",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3623",
  "totals-ui-components": "/totals-ui-components/static-1.23572",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9232",
  "advanced-menus-core": "/advanced-menus-core/static-1.15117",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12060",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34023",
  "segments-query-core": "/segments-query-core/static-1.1414",
  "demographics-service-types": "/demographics-service-types/static-1.1647",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3179",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5697",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7335",
  "data-token-views": "/data-token-views/static-1.16380",
  "forms-utils-lib": "/forms-utils-lib/static-1.12567",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13016",
  "simple-menus-core": "/simple-menus-core/static-1.15116",
  "simple-menus-lib": "/simple-menus-lib/static-1.16633",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4250",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6808",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7512",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3502",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2590",
  "ContentEditorUI": "/ContentEditorUI/static-2.77092",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3965",
  "web-interactives-components": "/web-interactives-components/static-1.13751",
  "web-interactives-data": "/web-interactives-data/static-1.13752",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.560",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.730",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.971",
  "line-items-api": "/line-items-api/static-1.679",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3813",
  "FireAlarmUi": "/FireAlarmUi/static-1.4508",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4165",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21717",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21180",
  "data-studio-ubb": "/data-studio-ubb/static-1.2701",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27006",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57783",
  "content-management-data-lib": "/content-management-data-lib/static-1.5376",
  "copilot-plugins": "/copilot-plugins/static-1.11089",
  "cta-picker": "/cta-picker/static-1.36378",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3060",
  "editor-components": "/editor-components/static-1.13220",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8392",
  "error-messaging-js": "/error-messaging-js/static-1.5187",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85822",
  "pictos": "/pictos/static-7.184",
  "react-transition-group": "/react-transition-group/static-2.64",
  "redux-request-state": "/redux-request-state/static-1.10641",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1743",
  "smart-content-core": "/smart-content-core/static-1.42416",
  "smart-content-lib": "/smart-content-lib/static-1.43069",
  "social-composer-lib": "/social-composer-lib/static-1.59070",
  "structured-content-lib": "/structured-content-lib/static-1.25166",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53230",
  "tinymce-copilot": "/tinymce-copilot/static-1.16412",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7890",
  "automation-ui-routing": "/automation-ui-routing/static-1.21138",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5634",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42178",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3174",
  "reporting-enablement": "/reporting-enablement/static-1.22895",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21247",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2580",
  "forms-ai-lib": "/forms-ai-lib/static-1.4310",
  "codemirror-dlb": "/codemirror-dlb/static-1.58651",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6426",
  "report-customization-components": "/report-customization-components/static-1.13142",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13013",
  "html-to-image": "/html-to-image/static-1.53",
  "reporting-filters": "/reporting-filters/static-1.304",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1724"
}
};
